import { HttpAgentService } from './../../service/http-agent.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AgentDto, DocumentDto, MsisdnDto, ResultListDto, SearchResultDocumentDto } from '../../service/dto';
import { Filter, OnTableChange, TableColumn } from '../../components/table/table.component';
import { Router } from '@angular/router';
import { HttpSubscriberService } from '../../service/http-subscriber.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-agent-list',
  standalone: false,
  templateUrl: './agent-list.component.html',
  styleUrl: './agent-list.component.scss'
})
export class AgentListComponent implements OnInit, OnDestroy {
	results?: ResultListDto<AgentDto>;
	loading = false;
	filters: Filter[] = [
		{ label: 'Username', name: 'username', type: 'Text', format: '^\\w+$' },
		{ label: 'Given Names', name: 'firstName', type: 'Text', format: '^\\w.*$' },
		{ label: 'Last Name', name: 'lastName', type: 'Text', format: '^\\w.*$' },
		{ label: 'Phone Number', name: 'msisdn', type: 'Text', format: '^\\w.*$' },
		{ label: 'Email Address', name: 'emailAddress', type: 'Text', format: '^\\w.*$' },
		{ label: 'ID Type', name: 'idType', type: 'Text', format: '^\\w.*$' },
		{ label: 'ID Number', name: 'idNumber', type: 'Text', format: '^\\w.*$' },
		{ label: 'Date Of Birth', name: 'dateOfBirth', type: 'Date', format: '^\\d{4}-\\d{2}-\\d{2}$' }
	];



	columnRef: TableColumn[] = [
		{ "title": "", "cellRef": "online" },
		{ "title": "Username", "property": "username" },
		{ "title": "Given Names", "cellRef": "givenNames",exportValue: item => `${item.firstName??''} ${item.secondName??''} ${item.otherNames??''}` },
		{ "title": "Last Name", "property": "lastName" },
		{ "title": "Phone Number", "property": "msisdn" },
		{ "title": "Email Address", "property": "emailAddress" },
		{ "title": "Date Of Birth", "property": "dateOfBirth" },
		{ "title": "Status", "property": "status" },
		{ "title": "ID Type", "property": "idType" },
		{ "title": "ID Number", "property": "idNumber" },
		{ "title": "Partner", "property": "partner.name" },
		{ "title": "Last Used", "cellRef": "lastUsed",exportValue: item => `${item.lastUsedAt}` },

	];



	constructor(private service: HttpAgentService, private router: Router) {
	}

	ngOnInit(): void { }

	ngOnDestroy(): void {
	}

	trackByHashCode(index: number, item: SearchResultDocumentDto): any {
		return item.hashCode;
	}

	open(input: AgentDto) {
		this.router.navigate(['/agent', 'view', input.id]);
	}
	doFetchResults(input: OnTableChange) {
		const filter: any = {
			username: input.filters.filter(i => i.name == 'username')[0]?.value,
			firstName: input.filters.filter(i => i.name == 'firstName')[0]?.value,
			lastName: input.filters.filter(i => i.name == 'lastName')[0]?.value,
			msisdn: input.filters.filter(i => i.name == 'msisdn')[0]?.value,
			emailAddress: input.filters.filter(i => i.name == 'emailAddress')[0]?.value,
			idType: input.filters.filter(i => i.name == 'idType')[0]?.value,
			idNumber: input.filters.filter(i => i.name == 'idNumber')[0]?.value,
			dateOfBirth: input.filters.filter(i => i.name == 'dateOfBirth')[0]?.value
		};
		this.loading = true;
		this.service.search(filter as AgentDto, input.pageIndex, input.pageSize)
			.pipe(finalize(() => {
				this.loading = false;
			}))
			.subscribe(result => {
				this.results = result;
			});
	}
}
